import { useDispatch } from "react-redux";
import { AuthWrapper, Box, RowCheckPassword, Title, Wrapper, WrapperCheckPassword } from "../style";
import { Button } from "shared/components/Button";
import { Input } from "shared/components/Input";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { showNotification } from "shared/redux/slice/notificationSlice";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Icon } from "shared/components/Icons";
import AuthService from "features/auth/services/AuthServices";

interface IPropsNewPasswordForm {
    code: string | null;
    login: string | null;
}

interface IPropsRecoveryPassword {
    password: string
    confirmPassword: string
}

export const NewPasswordForm = ({
    code,
    login
}: IPropsNewPasswordForm) => {
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const mutation = useMutation({
        mutationFn: ({ password }: { password: string }) => {
            return axios.post(`${process.env.API_OAUTH}/v1/user/recovery_password`, {
                login: login,
                code: code,
                new_password: password
            });
        },
        onError: (error) => {
            throw error
        },
        onSuccess: async (data) => {
            setIsSuccess(true)
            dispatch(showNotification({
                message: "Пароль изменен!",
                type: "success",
            }));

            const { tokens } = data.data;

            localStorage.setItem('token', tokens.access);
            localStorage.setItem('refresh', tokens.refresh);

            const userResponse = await AuthService.auth();
            localStorage.setItem('users', JSON.stringify(userResponse.data));

            const permissionsResponse = await AuthService.getPermissions(userResponse.data.role.id);
            localStorage.setItem('permissionsUsers', JSON.stringify(permissionsResponse.data.permissions));

            navigate('/')

        }
    })
    
    const formik = useFormik({
        initialValues: {
            password: '',
            confirmPassword: '',
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(8, 'Пароль должен содержать минимум 8 символов')
                .max(20, 'Пароль должен содержать максимум 20 символов')
                .matches(/[A-Z]/, 'Пароль должен содержать минимум одну заглавную букву')
                .matches(/[0-9]/, 'Пароль должен содержать минимум одну цифру')
                .matches(/[!?#$&@]/, 'Пароль должен содержать минимум один специальный символ (!?#$&@)')
                .required('Пароль обязателен'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password')], 'Пароли должны совпадать')
                .required('Подтверждение пароля обязательно'),
        }),
        onSubmit: (values: IPropsRecoveryPassword, { setSubmitting }) => {
            mutation.mutate({
                password: values.password
            })
            setSubmitting(false);
        },
    });

    const isPasswordValid = (password: string) => {
        return {
            minLength: password.length >= 8,
            hasUpperCase: /[A-Z]/.test(password),
            hasNumber: /[0-9]/.test(password),
            hasSpecialChar: /[!?#$&@]/.test(password),
            passwordsMatch: password === formik.values.confirmPassword && password.length !== 0
        };
    };

    const passwordValidity = isPasswordValid(formik.values.password);

    useEffect(() => {
        console.log(formik)
    }, [formik])
    
    if(isSuccess) {
        return (
            <AuthWrapper>
                <Box>
                    <Wrapper>
                        <Title>Пароль успешно изменен</Title>
                        <img style={{margin: "0 auto"}} src="/ok.png" alt="Пароль успешно изменен" width={100} height={100} />
                        <Button>
                            Готово
                        </Button>
                    </Wrapper>
                </Box>
            </AuthWrapper>
        )
    }

    return (
        <AuthWrapper>
            <Box>
                <Wrapper onSubmit={formik.handleSubmit}>
                    <Title>Придумайте новый пароль</Title>
                    <Input 
                        $beforeIcon="lock" 
                        $afterIcon="hidden"
                        type="password" 
                        label="Новый пароль" 
                        placeholder="Введите ваш пароль"
                        onChange={formik.handleChange}
                        value={formik.values.password}
                        name="password"
                        id="password"
                    />
                    <Input 
                        $beforeIcon="lock"
                        $afterIcon="hidden" 
                        type="password" 
                        label="Подтвердите  новый пароль" 
                        placeholder="Введите ваш пароль"
                        onChange={formik.handleChange}
                        value={formik.values.confirmPassword}
                        name="confirmPassword"
                        id="confirmPassword"
                    />
                    <WrapperCheckPassword>
                        <RowCheckPassword isValid={passwordValidity.minLength}>
                            <Icon name="check" />
                            <span>8 символов (20 макс)</span>
                        </RowCheckPassword>
                        <RowCheckPassword isValid={passwordValidity.hasUpperCase && passwordValidity.hasNumber}>
                            <Icon name="check" />
                            <span>1 заглавная буква и 1 цифра</span>
                        </RowCheckPassword>
                        <RowCheckPassword isValid={passwordValidity.hasSpecialChar}>
                            <Icon name="check" />
                            <span>1 специальный символ (Пример: # ! ? $ & @)</span>
                        </RowCheckPassword>
                        <RowCheckPassword isValid={passwordValidity.passwordsMatch}>
                            <Icon name="check" />
                            <span>Пароли должны совпадать</span>
                        </RowCheckPassword>
                    </WrapperCheckPassword>
                    <Button themeType="primary" type="submit" disabled={!formik.isValid || !formik.dirty}>Готово</Button>
                </Wrapper>
            </Box>
        </AuthWrapper>
    )
}